'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _print = require('../../../../../../print');

var _print2 = _interopRequireDefault(_print);

var _stages = require('../../../../../../stages');

var _ifeisIsomorphic = require('ifeis-isomorphic');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StageHeadersController = function () {
  function StageHeadersController(stages) {
    _classCallCheck(this, StageHeadersController);

    this.stages = stages;
  }

  _createClass(StageHeadersController, [{
    key: 'getEventName',
    value: function getEventName(event) {
      if (event) {
        (0, _ifeisIsomorphic.getDescription)(event);
      }
    }
  }]);

  return StageHeadersController;
}();

exports.default = angular.module('ifeis.routes.feiseanna.one.admin.reports.stage-headers', ['ifeis.printing', 'ifeis.stages.service']).config(function ($stateProvider) {
  $stateProvider.state('feiseanna.one.admin.reports.stage-headers', {
    url: '/stage-headers',
    template: require('./tpl.html'),
    controller: StageHeadersController,
    controllerAs: 'ctrl',
    resolve: {
      stages: function stages($stateParams, fStages, $q) {
        var stages = void 0;

        return fStages.for($stateParams.id).all().then(function (s) {
          stages = s;
          return $q.all(stages.map(function (s) {
            return s.schedule();
          }));
        }).then(function (s) {
          stages.forEach(function (stage, idx) {
            stage.$schedule = s[idx].filter(function (e) {
              return e.$placeholder !== true;
            });
          });

          return stages;
        });
      }
    }
  });
});


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/admin/reports/stage-headers/index.js
// module id = 567
// module chunks = 0